import { LinkTo } from "@ember/routing";

<template>
  <LinkTo data-test-header-search-result @route={{@route}} @models={{@models}} @query={{@query}} ...attributes>
    <div
      class="flex flex-1 text-sm cursor-pointer hover:bg-gray-100 leading-4 border-t border-gray-200 p-6
        {{if @active 'bg-gray-100 active'}}"
      data-test-search-result
    >
      <div class="mr-2 text-black font-mono" data-test-search-result-name>
        {{@name}}
      </div>
      {{#if @description}}
        <div class="text-gray-600" data-test-search-result-description>
          {{@description}}
        </div>
      {{/if}}
    </div>
  </LinkTo>
</template>
